import React, { useEffect, useState } from 'react';
import { Megaphone, Download, Copy, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Admin: auto-generated Women's Collection drop announcement graphic + captions.
export default function WomensLaunchPostCard() {
  const token = sessionStorage.getItem('admin_token');
  const [post, setPost] = useState(null);
  const [copied, setCopied] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/api/admin/womens-collection/launch-post`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then(setPost)
      .catch(console.error);
  }, [token]);

  const download = async () => {
    try {
      const res = await fetch(`${API_URL}${post.image_path}`);
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'ninjathlete-womens-collection-launch.png';
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (e) { console.error(e); }
  };

  const copyText = async (id, text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }
    setCopied(id);
    setTimeout(() => setCopied(''), 1600);
  };

  if (!post?.image_path) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5" data-testid="womens-launch-post-card">
      <div className="flex items-center gap-2 mb-1">
        <Megaphone className="w-4 h-4 text-pink-500" />
        <h3 className="text-sm font-bold text-gray-900">Women&apos;s Collection — Launch Post</h3>
        <span className="px-2 py-0.5 text-[10px] font-bold bg-pink-50 text-pink-600 rounded uppercase tracking-wider">{post.drop_label}</span>
      </div>
      <p className="text-xs text-gray-400 mb-4">
        Auto-generated 1080×1080 IG announcement for Drop 02 — regenerates automatically if the drop date changes.
      </p>
      <div className="flex gap-4 items-start">
        <img
          src={`${API_URL}${post.image_path}?v=${encodeURIComponent(post.drop_label)}`}
          alt="Women's Collection launch post"
          className="w-40 h-40 rounded border border-gray-200 object-cover"
          data-testid="womens-launch-post-img"
        />
        <div className="flex-1 min-w-0">
          <p className="text-[11px] text-gray-500 leading-relaxed line-clamp-4 mb-3">{post.captions.feed}</p>
          <div className="flex flex-wrap gap-1.5">
            <button onClick={download} className="inline-flex items-center gap-1 px-2 py-1 rounded bg-gray-900 text-white text-[10px] font-semibold" data-testid="womens-launch-post-download">
              <Download className="w-3 h-3" /> Download PNG
            </button>
            <button onClick={() => copyText('feed', post.captions.feed)} className="inline-flex items-center gap-1 px-2 py-1 rounded bg-lime-100 hover:bg-lime-200 text-lime-800 text-[10px] font-semibold" data-testid="womens-launch-post-copy-feed">
              {copied === 'feed' ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />} Feed caption
            </button>
            <button onClick={() => copyText('story', post.captions.story)} className="inline-flex items-center gap-1 px-2 py-1 rounded bg-gray-100 hover:bg-gray-200 text-gray-600 text-[10px] font-semibold" data-testid="womens-launch-post-copy-story">
              {copied === 'story' ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />} Story caption
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
